import React from 'react'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap'
import Loader from 'react-loader-spinner'
import SquareIcon from 'react-icons/lib/fa/square'
import UserIcon from 'react-icons/lib/fa/user'
import ServerIcon from 'react-icons/lib/fa/server'
import ConnectionIcon from 'react-icons/lib/fa/exchange'
import WarningIcon from 'react-icons/lib/fa/exclamation-triangle'
import '../../stylesheets/CommandStatusModal.css'


class CommandStatusModal extends React.Component {
    constructor(props) {
        super(props)
        const {className, toggle, modal, status, errorMessage} = props

        this.toggle = toggle
        this.state = {
            className,
            modal,
            status,
            errorMessage
        }
    }

    componentWillReceiveProps(nextProps) {
        const {className, toggle, modal, status, errorMessage} = nextProps

        this.toggle = toggle
        this.setState({
            className,
            modal,
            status,
            errorMessage
        })
    }

    render() {
        let {modal, status, errorMessage, className} = this.state

        return <Modal isOpen={modal} toggle={this.toggle} backdrop="static" className={className}>
            <ModalHeader toggle={this.toggle}>
                {(status === COMMAND_STATUSES.SUCCESS ?
                    "Settings Saved!" :
                    (status === COMMAND_STATUSES.FAILED_TO_SEND_TO_API ||
                    status === COMMAND_STATUSES.FAILED_TO_SEND_TO_CON ?
                        "Error" :
                        "Saving Settings"))}
            </ModalHeader>
            <ModalBody>
                <div className="row col-12 status-animation-container">
                    <div className="col-2 offset-1">
                        <UserIcon/>
                    </div>
                    <div className="col-2">
                        {(status === COMMAND_STATUSES.SENDING_TO_API ?
                            <Loader type="ThreeDots" color="black" width="20pt" height="20pt"/> :
                            (status === COMMAND_STATUSES.FAILED_TO_SEND_TO_API ?
                                <span className="text-warning"><WarningIcon/></span> :
                                <span className="text-success" style={{opacity: 0.7}}><ConnectionIcon/></span>))}
                    </div>
                    <div className="col-2">
                        <ServerIcon/>
                    </div>
                    <div className="col-2">
                        {(status === COMMAND_STATUSES.SENDING_TO_CON ||
                        status === COMMAND_STATUSES.WAITING_FOR_RESPONSE ?
                            <Loader type="ThreeDots" color="black" width="20pt" height="20pt"/> :
                            (status === COMMAND_STATUSES.FAILED_TO_SEND_TO_CON ?
                                <span className="text-warning"><WarningIcon/></span> :
                                (status === COMMAND_STATUSES.SUCCESS ?
                                    <span className="text-success" style={{opacity: 0.7}}><ConnectionIcon/></span> :
                                    null)))}
                    </div>
                    <div className="col-2">
                        <SquareIcon/>
                    </div>
                </div>
                {status}

                {(errorMessage ?
                    <span>
                        <br/>
                        <small>{errorMessage}</small>
                    </span> :
                    null)}
            </ModalBody>
            <ModalFooter>
                {(status === COMMAND_STATUSES.SUCCESS ||
                status === COMMAND_STATUSES.FAILED_TO_SEND_TO_API ||
                status === COMMAND_STATUSES.FAILED_TO_SEND_TO_CON ?
                    <Button color="secondary" onClick={this.toggle}>OK</Button> :
                    null)}
            </ModalFooter>
        </Modal>
    }
}

export default CommandStatusModal

export const COMMAND_STATUSES = {
    FAILED_TO_SEND_TO_CON: "Failed to save settings in Marksman controller.",
    FAILED_TO_SEND_TO_API: "Failed to send settings to Marksman service. Please check your internet connection.",
    SENDING_TO_API: "Sending settings to Marksman service...",
    SENDING_TO_CON: "Sending settings to Marksman controller...",
    WAITING_FOR_RESPONSE: "Waiting for response from Marksman controller...",
    SUCCESS: "Settings saved in Marksman controller."
}



// WEBPACK FOOTER //
// ./src/components/ui/CommandStatusModal.js